import PaginationTable from './pagination-table.vue';

export default PaginationTable;
